import { Injectable } from '@angular/core';
import { CONNECTION_TYPE_META } from '../utils/connection-type-meta';

@Injectable({ providedIn: 'root' })
export class ConnectionFormatterService {
  getBadgeClass(type: string | undefined | null): string {
    if (!type) return 'bg-gray-800 text-gray-200';
    return CONNECTION_TYPE_META[type.toLowerCase()]?.badgeClass || 'bg-gray-800 text-gray-200';
  }

  getConnectionTypeWithIcon(type: string): string {
    switch (type.toLowerCase()) {
      case 'ftp':
        return 'pi pi-cloud-upload';
      case 'sftp':
        return 'pi pi-cloud-download';
      case 'postgresql':
        return 'pi pi-database';
      case 'rest':
        return 'pi pi-link';
      case 'restlet':
        return 'pi pi-share-alt';
      case 'netsuite':
        return 'pi pi-sliders-h';
      default:
        return 'pi pi-question';
    }
  }

  getSeverity(type: string): 'success' | 'info' | 'warn' | 'contrast' | 'secondary' | null {
    switch (type) {
      case 'ftp':
        return 'info';
      case 'sftp':
        return 'success';
      case 'postgresql':
        return 'warn';
      case 'rest':
        return 'contrast';
      case 'restlet':
        return 'secondary';
      case 'netsuite':
        return 'info';
      default:
        return null;
    }
  }
}
